document.addEventListener('DOMContentLoaded', function() {
  const MOBILE_MAX = 750;
  const $commonIconLists = $('.product-overview .common-icon-list');
  var prevWindowWidth = window.innerWidth;

  function isCarouselList($list) {
    return $list.hasClass('mobile-iconlist-carousel');
  }

  function unslickList($list) {
    if ($list.hasClass('slick-initialized')) {
      $list.slick('unslick');
    }
  }

  function resizeHandle() {
    let currWindowWidth = window.innerWidth;
    if (currWindowWidth != prevWindowWidth) {
      $commonIconLists.each(function () {
        const $list = $(this);
        if ($(window).width() <= MOBILE_MAX && isCarouselList($list)) {
          initSlick($list);
        } else {
          unslickList($list);
        }
      });
      prevWindowWidth = currWindowWidth;
    }
  }

  function initSlick(commonIconList) {
    if (!isCarouselList(commonIconList)) {
      unslickList(commonIconList);
      return;
    }
    if (commonIconList.hasClass('slick-initialized')) {
      commonIconList.slick('unslick');
    }
    if ($(window).width() <= MOBILE_MAX) {
      commonIconList.slick({
        infinite: true,
        draggable: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        dots: true
      });
    }
  }
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  $commonIconLists.each(function () {
    initSlick($(this));
  });
  window.addEventListener('resize', debounce(resizeHandle, 200));

  // Animation
  $(document).on(`mouseenter`, `.enable-animation`, function(e) {
    e.preventDefault();
    e.stopPropagation();
    if(!$(this).hasClass('animation-active') && window.innerWidth >= 751) {
      $(this).addClass('animation-active');
    }
  });
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      let parentEl = entry.target
      if (entry.isIntersecting && !parentEl.classList.contains("animation-active") && window.innerWidth >= 751) {
        parentEl.classList.add("animation-active");

        observer.unobserve(parentEl); // 只执行一次
      }
    });
  }, { threshold: 0.5 }); // 元素有 50% 出现在视口时触发

  $('.product-overview.enable-animation').each(function() {
    observer.observe(this);
  });
});